import React from 'react';
import {SpartanTextFieldProps} from './model';
import {SpartanTextField} from './SpartanTextField';

export const SpartanEmailField = ({InputProps, ...props}: SpartanTextFieldProps) => (
  // Do not pass `type: email` to InputProps to prevent nasty HTML5 validation tooltip.
  // We apply validation via regex anyway.
  <SpartanTextField {...props} />
);
